'use strict';

var ACC;
ACC.recentlyviewed = {
    sendGtmViewedProductInfo: function (gtmRecentlyViewed) {
        var viewedProducts = ACC.utils.getFromLocalStorage('viewedProducts');
        var currentProductCode = $('.recently-viewed-data').data('product-code').toString() || '';

        if (gtmRecentlyViewed && viewedProducts && viewedProducts.length) {
            var componentId = gtmRecentlyViewed['id'];
            var recentlyViewedExceptCurrent =
                viewedProducts
                    .filter(function (product) {
                        if (product && (typeof (product['id']) !== 'undefined')) {
                            return currentProductCode !== product['id'].toString();
                        }
                    })
                    .map(function (product, index) {
                        return {
                            "name": product['productName'],
                            "brand": product['brandName'],
                            "position": index + 1,
                            "list": "Recently Viewed Products Carousel",
                            "id": product['id'].toString(),
                            "price": product['productPrice'],
                            "categoryPath": product['productUrl']
                        };
                    });

            gtmRecentlyViewed['totalImpression'] = recentlyViewedExceptCurrent.length;
            gtmRecentlyViewed['viewNumber'] = 1;
            gtmRecentlyViewed['ecommerce']['impressions'] = recentlyViewedExceptCurrent;

            ACC.gtm.gtmPushOrDelayEventData(gtmRecentlyViewed, componentId, ACC.gtm.collectProductImpressions);
        }
    },
    sendGaViewedProductInfo: function (gaRecentlyViewed) {
        var viewedProducts = ACC.utils.getFromLocalStorage('viewedProducts');
        var currentProductCode = $('.recently-viewed-data').data('product-code').toString() || '';

        if (gaRecentlyViewed && viewedProducts && viewedProducts.length) {
            var componentId = gaRecentlyViewed['id'];
            var recentlyViewedExceptCurrent =
                viewedProducts
                    .filter(function (product) {
                        if (product && (typeof (product['id']) !== 'undefined')) {
                            return currentProductCode !== product['id'].toString();
                        }
                    })
                    .map(function (product, index) {
                        var categoryArray = product['productUrl']?.split('/');
                        var categroyIndex = product['productUrl'] && (product['productUrl']?.indexOf('/') === 0 ? 1 : 0) || 0;  // skip first element if it starts with '/'
                        return {
                            "item_name": product['productName'],
                            "item_brand": product['brandName'],
                            "index": index + 1,
                            "list_name": "Recently Viewed Products Carousel",
                            "item_id": product['id'].toString(),
                            "item_list_id": "recently_viewed_carousel",
                            "item_list_name": "carousel: recently_viewed",
                            "price": product['productPrice'] && +product['productPrice'],
                            "item_category": categoryArray && (categoryArray[categroyIndex++] || null),
                            "item_category2": categoryArray && (categoryArray[categroyIndex++] || null),
                            "item_category3": categoryArray && (categoryArray[categroyIndex++] || null),
                            "item_category4": categoryArray && (categoryArray[categroyIndex++] || null),
                            "item_category5": categoryArray && (categoryArray[categroyIndex++] || null),
                        };
                    });

            gaRecentlyViewed['list_size'] = recentlyViewedExceptCurrent.length;
            gaRecentlyViewed['creative_slot'] = 1;
            gaRecentlyViewed['items'] = recentlyViewedExceptCurrent;

            ACC.gtmToGa.gaPushOrDelayEventData(gaRecentlyViewed, componentId, ACC.gtmToGa.collectProductImpressions);
        }
    }
};
